<mat-sidenav-container>
  <mat-sidenav #sidenav id="sidenav" [ngStyle]="{ 'width.px': sidenavWidth }" class="primary-color">
    <div class="overflowed" style="max-height: 100vh">
      <div class=" container-fluid py-3">
        <!-- <div class="row" style="margin-bottom:15px;">
          <span id="c_logo" class="mx-auto d-block"><a href="#" id="company_name"
              style.color="{{_companies.color}}"><img src={{_companies.logo}} /><span
                style="position:relative;top:5px;color:#f4f4f4;"
                *ngIf="flag == true">{{_companies.name}}</span></a></span>
        </div> -->

        <div class="flex gap-2">
          <div
            class="flex {{flag ? 'ml-0' : '-ml-2'}} items-center rounded overflow-hidden justify-center w-9 h-9 min-w-9 ">
            <img src="{{company?.logo}}" onerror="this.src='assets/images/edozzier-logo.png'" class="h-full " />
          </div>

          <div *ngIf="flag == true" class="flex flex-col -space-y-1">
            <p class="text-white font-medium uppercase">
              {{company?.adm_initial}}</p>
            <span class="text-xs text-gr200">Student Portal</span>
          </div>
        </div>

        <span *ngIf="flag && system == 'tert'">
          <button
            class="w-full px-3 py-2 rounded flex justify-between gap-2 items-center text-white bg-white/10 uppercase text-sm mt-3"
            [matMenuTriggerFor]="prog">
            <span>{{ current_program }}</span>
            <i class='bx bx-chevron-down'></i>
          </button>
          <mat-menu #prog="matMenu">
            <div *ngFor="let program of programArr">
              <button mat-menu-item [ngStyle]="{
                  'background-color':
                    program.current_program !== false ? '#F4F5F5' : 'white'
                }" (click)="switchProgram(program.st_pr_id)">
                {{ program.name }}
              </button>
            </div>
          </mat-menu>
        </span>
        <div class="row" id="nav-items" *ngFor="let item of items">
          <mat-nav-list *ngIf="flag == true; else itemselse">
            <!-- <mat-divider style="width:100%;border-top-color:#080a27;" *ngIf="!last"></mat-divider> -->
            <h4 class="text-sm px-3" style="color:#aca6a6;">{{item.name}}</h4>
            <a mat-list-item routerLink="{{x._name}}" (click)="closeIt()" *ngFor="let x of item.sub">
              <span class="flex items-center h-full">
                <span><mat-icon>{{x.icon}}</mat-icon></span>
                &nbsp;&nbsp;&nbsp;
                <span style="color:#edeaea;" class="relative">{{x.name}}
                  <span class="bg-blue-500 absolute ml-2 -top-2 text-white rounded-md px-2 py-0.5 text-[.65rem]"
                    *ngIf="x.tag">{{x.tag}}</span>
                </span>
              </span>
            </a>
          </mat-nav-list>

          <ng-template #itemselse>
            <mat-nav-list>
              <a mat-list-item routerLink="{{x._name}}" matTooltip="{{x._name}}" matTooltipPosition="right"
                (click)="closeIt()" *ngFor="let x of item.sub">
                <mat-icon style="font-size:1.5em;color:#fff;">{{x.icon}}</mat-icon>
              </a>
            </mat-nav-list>
          </ng-template>
        </div>
      </div>
    </div>
    <!-- <mat-accordion>
          <mat-expansion-panel *ngFor = "let item of items"  style="box-shadow:none;">
              <mat-expansion-panel-header>
                <mat-panel-title>
                 <a routerLink="/{{item._name}}" *ngIf="item._name ==='dashboard'; else elseBlock" (click)='closeIt()'><mat-icon>{{item.icon}}</mat-icon> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.name}}</a> 
                </mat-panel-title>
                <ng-template #elseBlock>
                    <a><mat-icon>{{item.icon}}</mat-icon> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.name}}</a> 
                </ng-template>
              </mat-expansion-panel-header>
            <mat-list>
                <mat-list-item *ngFor="let x of item.sub"><a routerLink="/{{x._name}}" (click)="closeIt()">{{x.name}}</a></mat-list-item>
            </mat-list>
          </mat-expansion-panel>
        </mat-accordion> -->
  </mat-sidenav>
  <mat-sidenav-content style="min-height: 100dvh;">
    <mat-toolbar [ngStyle]="{width: sidenav.opened ? 
        'calc(100vw - 13rem)' : 'calc(100vw - 1.5rem)'
      }">
      <div class="disp-sm w-full">
        <div class="flex gap-4 justify-between items-center">
          <div>
            <button mat-icon-button (click)="sidenav.open()" id="tog">
              <mat-icon class="text-light">menu</mat-icon>
            </button>
            <span id="loader" *ngIf="loading">
              <mat-spinner class="mx-auto" style="display:inline-block;" [diameter]="20" color="accent"
                mode="indeterminate"></mat-spinner>
            </span>
          </div>

          <div class="flex w-full text-slate-200 justify-end items-center gap-4">
            <button title="Help" routerLink="help"
              class="hover:bg-white/20 border-slate-500 transition h-9 w-9 min-w-9 rounded-md border-[1px] items-center justify-center">
              ?
            </button>

            <button title="Notice Board" routerLink="notice-board"
              class="hover:bg-white/20 border-slate-500 transition text-lg pt-0.5 h-9 w-9 min-w-9 rounded-md border-[1px] items-center justify-center">
              <i class='bx bx-notification'></i>
            </button>

            <button title="Noifications" routerLink="notifications" matBadge="{{notification_count}}" matBadge
              matBadgeSize="small" (click)="clearBadge()"
              class="hover:bg-white/20 border-slate-500 transition text-lg pt-0.5 h-9 w-9 min-w-9 rounded-md border-[1px] items-center justify-center">
              <i class='bx bx-bell'></i>
            </button>

            <button class="flex items-center gap-2" [matMenuTriggerFor]="prof">
              <img src="{{student?.passport}}" class="h-9 min-w-9 w-9 rounded-md object-cover"
                onerror="this.src='assets/images/man.png'" />
              <div class="flex flex-col text-left">
                <span class="text-sm capitalize">{{student?.firstname | lowercase}}</span>
                <p class="text-xs" *ngIf="system != 'psec'">{{student?.matric_no}}</p>
                <p class="text-xs" *ngIf="system == 'psec'">{{student?.student_id}}</p>
              </div>
              <i class='bx bx-chevron-down'></i>
            </button>

            <mat-menu class="mt-2" #prof="matMenu">
              <button mat-menu-item routerLink="my-profile">
                <span class="flex items-center gap-2 pr-12">
                  <i class='bx bx-user'></i> My Profile
                </span>
              </button>
              <button mat-menu-item routerLink="logout">
                <span class="flex items-center gap-2 text-red-700">
                  <i class='bx bx-power-off'></i> Log out
                </span>
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
      <div class="w-full disp-lg pr-6">
        <div class="d-flex items-center justify-between">
          <div>
            <span (click)="recon()"><button mat-icon-button (click)="sidenav.open()" id="tog">
                <mat-icon>menu</mat-icon>
              </button>
            </span>
            <span id="loader" *ngIf="loading">
              <mat-spinner class="mx-auto" style="display:inline-block" [diameter]="25" color="primary"
                mode="indeterminate"></mat-spinner>
            </span>
          </div>
          <div class="flex justify-end items-center gap-4">

            <div
              class="bg-white pr-4 hidden lg:flex border-r -space-y-0.5 h-9 flex-col justify-center items-end relative"
              *ngFor="let item of getCards()">
              <span class="text-sm font-semibold uppercase">{{item.value}}</span>
              <p class="text-xs text-ndgray">{{item.label}}</p>
            </div>

            <span *ngIf="!flag && system == 'tert'">
              <button
                class="w-full px-3 py-2 rounded flex justify-between gap-2 items-center bg-primary1/10 uppercase text-sm"
                [matMenuTriggerFor]="prog">
                <span>{{ current_program }}</span>
                <i class='bx bx-chevron-down'></i>
              </button>
              <mat-menu #prog="matMenu" class="mt-2">
                <div *ngFor="let program of programArr">
                  <button mat-menu-item [ngStyle]="{
                  'background-color':
                    program.current_program !== false ? '#F4F5F5' : 'white'
                }" (click)="switchProgram(program.st_pr_id)">
                    {{ program.name }}
                  </button>
                </div>
              </mat-menu>
            </span>

            <button title="Help" routerLink="help"
              class="hover:bg-slate-100 transition h-9 w-9 min-w-9 rounded-md border-[1px] items-center justify-center">
              ?
            </button>

            <button title="Notice Board" routerLink="notice-board"
              class="hover:bg-slate-100 transition text-lg pt-0.5 h-9 w-9 min-w-9 rounded-md border-[1px] items-center justify-center">
              <i class='bx bx-notification'></i>
            </button>

            <button title="Noifications" routerLink="notifications" matBadge="{{notification_count}}" matBadge
              matBadgeSize="small" (click)="clearBadge()"
              class="hover:bg-slate-100 transition text-lg pt-0.5 h-9 w-9 min-w-9 rounded-md border-[1px] items-center justify-center">
              <i class='bx bx-bell'></i>
            </button>

            <button class="flex items-center gap-2" [matMenuTriggerFor]="prof">
              <img src="{{student?.passport}}" class="h-9 min-w-9 w-9 rounded-md object-cover"
                onerror="this.src='assets/images/man.png'" />
              <div class="flex flex-col text-left">
                <span class="text-sm capitalize font-semibold">{{student?.firstname | lowercase}}
                  {{student?.lastname | lowercase}}</span>
                <p class="text-xs" *ngIf="system != 'psec'">{{student?.matric_no}}</p>
                <p class="text-xs" *ngIf="system == 'psec'">{{student?.student_id}}</p>
              </div>
              <i class='bx bx-chevron-down'></i>
            </button>

            <mat-menu class="mt-2" #prof="matMenu">
              <button mat-menu-item routerLink="my-profile">
                <span class="flex items-center gap-2 pr-12">
                  <i class='bx bx-user'></i> My Profile
                </span>
              </button>
              <button mat-menu-item routerLink="logout">
                <span class="flex items-center gap-2 text-red-700">
                  <i class='bx bx-power-off'></i> Log out
                </span>
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
      <!-- <div id="toolbar-body"> -->

      <!-- <span><a href="#" id="company_name" style.color="{{_companies.color}}"><img src={{_companies.logo}} /><span style="position:relative;top:-9px;">{{_companies.name}}</span></a></span> -->
      <!-- <span class="fill"></span>
              <span class="fill"></span>
              <span class="fill"></span> -->

      <!-- </div> -->
    </mat-toolbar>
    <router-outlet></router-outlet>
  </mat-sidenav-content>

</mat-sidenav-container>